import React, { Component } from 'react';
import { connect } from 'react-redux';
import { IColumn, Selection } from '@fluentui/react';
import history from '../../../history';

import ListPaneComponent from './component';
import { withRouter } from 'react-router';
import { WithTranslation, withTranslation } from 'react-i18next';
import { readRiskRegisterDropDownData } from '../../../reducers/riskRegisterReducer';
import { messageService } from '../../../services/messageService';
import {
  formData,
  RiskRegister,
  RiskRegisterDropDowns,
  RiskRegisterListItem,
  RiskRegisterListPaneFilter,
} from '../../../types/riskRegister';
import { getContractingUnit, getProject } from '../../../shared/util';

export interface State {
  redirect: boolean;
  isChange: boolean;
  loading: boolean;
  filter: RiskRegisterListPaneFilter;
  announcedMessage: string;
  selectedListItemIds: [] | string[];
  selectedListItemSequenceCode: [] | string[];
  formData: RiskRegister;
  selectedListItems: RiskRegisterListItem[];
}

export interface Props extends WithTranslation {
  listPaneItems: RiskRegisterListItem[];
  reloadListPaneItem: () => void;
  handelFilter: (filter: RiskRegisterListPaneFilter) => void;
  isDataLoaded?: boolean;
  isChange: boolean;
  filter: RiskRegisterListPaneFilter;
  resourceTypes: [];
  loadMsg: string;
  toleranceStatesFilter: [];
  productStatesFilter: [];
  itemTypesFilter: [];
  handleSelectedListPaneItem: (selectedItemIds: [] | string[]) => void;
  formData: RiskRegister;
  projectId: string | null;
  rrDropDowns: RiskRegisterDropDowns;
  reSizer: number;
  readRiskRegisterDropDownData: () => void;
}

class ListPane extends Component<Props, State> {
  private _Selection: Selection;
  private _columns: IColumn[];
  private _columnsReSizer: IColumn[];
  private _columnsCu: IColumn[];
  subscription: any;

  constructor(props: Props) {
    super(props);
    this._Selection = new Selection({
      onSelectionChanged: () => {
        this.setState(
          {
            selectedListItemIds: this._getSelectedIds(),
            selectedListItemSequenceCode: this._getselectedSequenceCode(),
            selectedListItems: this._getSelectedListItems(),
          },
          this.handleSelectedItem,
        );
      },
    });
    this.state = {
      selectedListItems: [],
      selectedListItemIds: [],
      selectedListItemSequenceCode: [],
      redirect: false,
      isChange: false,
      loading: false,
      announcedMessage: '',
      filter: new RiskRegisterListPaneFilter(),
      formData: formData,
    };

    this._columns = [
      {
        key: 'column1',
        name: this.props.t('riskTitle'),
        fieldName: 'title',
        minWidth: 165,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      // {
      //   key: 'column2',
      //   name: this.props.t('Risk ID'),
      //   fieldName: 'sequenceCode',
      //   minWidth: 100,
      //   maxWidth: 200,
      //   isResizable: true,
      //   onColumnClick: this._onColumnClick,
      //   //className: 'totalAmountCol'
      // },
      {
        key: 'column3',
        name: this.props.t('status'),
        fieldName: 'riskStatus',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column4',
        name: this.props.t('riskType'),
        fieldName: 'riskType',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      // {
      //   key: 'column5',
      //   name: this.props.t('Date'),
      //   fieldName: 'Date',
      //   minWidth: 100,
      //   maxWidth: 200,
      //   isResizable: true,
      //   onColumnClick: this._onColumnClick,
      // },
      {
        key: 'column5',
        name: this.props.t('riskOwner'),
        fieldName: 'person',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
    ];
    this._columnsReSizer = [
      {
        key: 'column1',
        name: this.props.t('title'),
        fieldName: 'title',
        minWidth: 165,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
    ];
    this._columnsCu = [
      {
        key: 'column1',
        name: this.props.t('title'),
        fieldName: 'title',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        isSorted: true,
        isSortedDescending: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column2',
        name: this.props.t('riskID'),
        fieldName: 'sequenceCode',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column3',
        name: this.props.t('Status'),
        fieldName: 'riskStatus',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
      },
      {
        key: 'column4',
        name: this.props.t('riskType'),
        fieldName: 'riskType',
        minWidth: 100,
        maxWidth: 200,
        isResizable: true,
        onColumnClick: this._onColumnClick,
        //className: 'totalAmountCol'
      },
      // {
      //   key: 'column5',
      //   name: this.props.t('date'),
      //   fieldName: 'date',
      //   minWidth: 100,
      //   maxWidth: 200,
      //   isResizable: true,
      //   onColumnClick: this._onColumnClick,
      // },
      // {
      //   key: 'column5',
      //   name: this.props.t('Risk Owner'),
      //   fieldName: 'person',
      //   minWidth: 100,
      //   maxWidth: 200,
      //   isResizable: true,
      //   onColumnClick: this._onColumnClick,
      // },
    ];
  }

  // static getDerivedStateFromProps(nextProps: any) {
  //   if (nextProps.isChange) {
  //     nextProps.reloadListPaneItem();
  //   }
  //   return {
  //     loading: false,
  //     filter: nextProps.filter,
  //     formData: nextProps.formData,
  //   };
  // }

  componentDidMount() {
    this.subscription = messageService.getMessage().subscribe((data: any) => {
      if (data) {
        if (data.data.isNewRR) {
          this._Selection.selectToKey('', true);
        }
        if (data.data.resetListPaneSelection) {
          this._Selection.setAllSelected(false);
          this.resetSelection();
        }
      }
    });
  }

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevProps.isDataLoaded != this.props.isDataLoaded) {
      if (this.props.isDataLoaded) {
        this.resetSelection();
      }
    }
    if (prevProps.rrDropDowns != this.props.rrDropDowns) {
      // console.log('msg',this.props.rrDropDowns)
    }

  }

  // handleListPaneItemClick = (id: string) => {
  //   history.push(`/CU/${getContractingUnit()}/template/${id}`);
  // };

  handleListPaneItemClick = (sequenceCode: string) => {//change to load document pane
    //this.props.getById(id);
    // console.log("ggggggggggg",sequenceCode)
    if (getContractingUnit() && !getProject()) {
      history.push(`/CU/${getContractingUnit()}/risk-register/${sequenceCode}`);
    } else {
      history.push(`/CU/${getContractingUnit()}/project/${getProject()}/risk-register/${sequenceCode}`);
    }
  };

  // handleSelectedItem = () => {
  //   this.props.handleSelectedListPaneItem(this.state.selectedListItemIds);
  //   if (this.state.selectedListItemSequenceCode) {
  //     let lastId = this.state.selectedListItemSequenceCode.pop();
  //     if (lastId) {
  //       this.handleListPaneItemClick(lastId);
  //     }
  //   }
  // };
  handleSelectedItem = () => {
    this.props.handleSelectedListPaneItem(this.state.selectedListItemIds);
    if (this.state.selectedListItemSequenceCode) {
      let lastId = this.state.selectedListItemSequenceCode.pop();
      if (lastId) {
        if (getContractingUnit() && !getProject()) {
          history.push(`/CU/${getContractingUnit()}/risk-register/${lastId}`);
        } else {
          history.push(`/CU/${getContractingUnit()}/project/${getProject()}/risk-register/${lastId}`);
        }
      }
    }
  };

  handleFilterChange = (filter: RiskRegisterListPaneFilter) => {
    this.props.handelFilter(filter);
  };

  handleFilterSortChange = () => {
    this.props.handelFilter(this.state.filter);
  };

  resetSelection = () => {
    if (
      this.state.formData &&
      this.state.formData.id &&//change
      this.props.isDataLoaded
    ) {
      this._Selection.setKeySelected(
        this.state.formData.id,//change
        true,
        false,
      );
    } else {
      this._Selection.selectToKey('', true);
    }
  };

  render() {
    return (
      <div>
        <ListPaneComponent
          listPaneItems={
            this.props.listPaneItems ? this.props.listPaneItems : []
          }
          selection={this._Selection}
          handleListPaneItemClick={(sequenceCode: string) =>//change to load document pane
            this.handleListPaneItemClick(sequenceCode)
          }
          resetSelection={() => this.resetSelection()}
          formData={this.state.formData}
          columns={(getProject()) ? (this.props.reSizer === 300) ? this._columnsReSizer : this._columns : (this.props.reSizer === 300) ? this._columnsReSizer : this._columnsCu}
          filter={this.props.filter}
          loadMsg={this.props.loadMsg}
          handleFilterChange={(filter: RiskRegisterListPaneFilter) =>
            this.handleFilterChange(filter)
          }
          isDataLoaded={this.props.isDataLoaded}
          dropDownOptions={this.props.rrDropDowns}
        />
      </div>
    );
  }

  private _getSelectedIds() {
    let deleteList: any = [];
    let SelectedItem = this._Selection.getSelection() as RiskRegisterListItem[];
    if (SelectedItem) {
      deleteList = SelectedItem.map((item: any) => {
        return item ? item.id : null;
      });
    }
    return deleteList;
  }

  private _getselectedSequenceCode() {
    let selectedList: any = [];
    let selectedItem = this._Selection.getSelection() as RiskRegisterListItem[];
    if (selectedItem) {
      selectedList = selectedItem.map((item: any) => {
        return item ? item.progressStatementId : null;
      });
    }
    return selectedList;
  }

  private _getSelectedListItems = () => {
    let SelectedListItems = this._Selection.getSelection() as RiskRegisterListItem[];

    return SelectedListItems;
  };

  private _onColumnClick = (
    ev: React.MouseEvent<HTMLElement>,
    column: IColumn,
  ): void => {
    const newColumns: IColumn[] = this._columns.slice();
    const currColumn: IColumn = newColumns.filter(
      (currCol) => column.key === currCol.key,
    )[0];
    newColumns.forEach((newCol: IColumn) => {
      if (newCol === currColumn) {
        currColumn.isSortedDescending = !currColumn.isSortedDescending;
        currColumn.isSorted = true;
        let filter = this.state.filter;

        let fieldName = currColumn.fieldName;

        let sortby = currColumn.isSortedDescending ? 'desc' : 'asc';
        filter.sortingModel.attribute = fieldName ? fieldName : null;
        filter.sortingModel.order = sortby ? sortby : null;
        this.setState(
          {
            filter: filter,
          },
          this.handleFilterSortChange,
        );
      } else {
        newCol.isSorted = false;
        newCol.isSortedDescending = true;
      }
    });
  };
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    // toleranceStatesFilter:state.projectBreakdown.toleranceStatesFilter,
    // productStatesFilter: state.projectBreakdown.productStatesFilter,
    // itemTypesFilter: state.projectBreakdown.itemTypesFilter,
    isChange: state.rr.isChange,
    rrDropDowns: state.rr.rrDropDowns,
  };
};

const mapDispatchToProps = {
  readRiskRegisterDropDownData,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(withTranslation()(ListPane)),
);
